import React, { memo } from 'react';
import type { BlockRendererProps } from '../../RegistryProvider/types';
import { useTriggerAutomaticDataSources } from '../../DataSourceController/hooks/useTriggerAutomaticDataSources';
import useSetBlockLifecycle from '../../../hooks/useSetBlockLifecycle';

export const withBlockEffects = (WrappedComponent: React.ComponentType<BlockRendererProps>) => {
  function WithBlockEffectsWrapper(props: BlockRendererProps) {
    const { block } = props;

    useTriggerAutomaticDataSources({
      dataSourceIds: block.dataSourceIds || [],
    });

    // whenever we are attempting to render a block, we set the lifecycle of that block to staging
    // regardless of whether the block would be completely rendered or not because of visibility conditions, permissions etc
    // so far this is the usecase - this is because we need to decide if we need to fetch aggregation metadata for the block or not
    useSetBlockLifecycle(block.id, block.component.componentType);

    return <WrappedComponent {...props} />;
  }

  return memo(WithBlockEffectsWrapper);
};
